import React, { Component } from 'react';
import injectSheet from 'react-jss';
import {
  Card, CardBody, Media,
} from 'reactstrap';
import classNames from 'classnames';

const styles = {
  cardContainer: {
    marginBottom: '2rem',
    boxShadow: '0 0.125rem 0.75rem -0.125rem rgba(0, 0, 0, 0.25)',
    borderRadius: '0.3125rem',
  },
  card: {
    minWidth: '37.5rem',
    maxWidth: '37.5rem',
    borderRadius: '0.3125rem',
  },
  selectWrapper: {
    // marginBottom: '1rem',
  },
  cardTitle: {
    fontFamily: 'Lato, Arial',
    fontSize: '0.875rem',
    color: '#1F1F1F',
    fontWeight: 'bold',
    marginBottom: '0.3125rem',
    marginTop: '1rem',
  },
  description: {
    fontFamily: ' Lato, Arial',
    fontSize: '0.875rem',
    color: '#656565',
    marginBottom: '0.3125rem',
    lineHeight: '1.313rem',
  },
  participantInfoWrapper: {
    display: 'flex',
    border: '1px solid #E5E7E6',
    borderRadius: '1.5rem',
    padding: '3px',
  },
  participantName: {
    marginLeft: '0.5rem',
    fontFamily: 'Lato, Arial',
    fontSize: '0.875rem',
    color: '#1F1F1F',
    fontWeight: 'bold',
    lineHeight: '1.875rem',
  },
  imageWrapper: {
    width: '2rem',
    height: '2rem',
    display: 'flex',
    position: 'relative',
    overflow: 'hidden',
    fontSize: '1.25rem',
    flexShrink: 0,
    fontFamily: 'Lato',
    alignItems: 'center',
    userSelect: 'none',
    borderRadius: '50%',
    justifyContent: 'center',
  },
  image: {
    width: '100%',
    height: '100%',
    textAlign: 'center',
    objectFit: 'cover',
  },
  chipWrapper: {
    composes: ['chip-wrapper'],
    margin: '0.2rem',
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #E5E7E6',
    borderRadius: '1.5rem',
    padding: '0.1875rem 1rem 0.1875rem 0.1875rem',
    width: 'max-content',
  },
  FutureBtnWrapper: {
    border: '0.0625rem solid #34A5DA',
    color: '#34A5DA',
    fontFamily: 'Lato, Arial',
    fontSize: '0.875rem',
    width: 'max-content',
    borderRadius: '1.5rem',
    padding: '0.1875rem 0.625rem',
    cursor: 'pointer',
    lineHeight: '1.125rem',
    float: 'right',
    marginTop: '1rem',
    '&:hover': {
      color: '#fff',
      backgroundColor: '#34A5DA',
    },
  },
  previousBtnWrapper: {
    border: '0.0625rem solid #34A5DA',
    color: '#34A5DA',
    fontFamily: 'Lato, Arial',
    fontSize: '0.875rem',
    width: 'max-content',
    borderRadius: '1.5rem',
    padding: '0.1875rem 0.625rem',
    cursor: 'pointer',
    lineHeight: '1.125rem',
    float: 'right',
    marginTop: '1rem',
    marginRight: '0.5rem',
    '&:hover': {
      color: '#fff',
      backgroundColor: '#34A5DA',
    },
  },
  sessionBtn: {
    border: '0.0625rem solid #34A5DA',
    background: '#34A5DA',
    color: '#FFFFFF',
    fontFamily: 'Lato, Arial',
    fontSize: '0.875rem',
    width: 'max-content',
    borderRadius: '1.5rem',
    padding: '0.1875rem 0.625rem',
    cursor: 'default',
    lineHeight: '1.125rem',
    float: 'right',
    marginTop: '1rem',
    marginRight: '0.5rem',
  },
  participantContainer: {
    height: '6rem',
  },
  hide: {
    display: 'none',
  },
  btnWrapper: {
    display: 'inline-block',
    'float': 'left',
  },
};

class ManagementParticipantsSessionCard extends Component {
  renderParticipants = () => {
    const {
      classes, participants, removeFromFutureBtn, removeFromPreviousBtn, wrapUp, isRemovedFromLastSession,
    } = this.props;
    return (
      participants.map((participant, index) => {
        return (
          <div key={index} className={classes.participantContainer}>
            <div  className={classes.participantInfoWrapper}>
              <div className={classes.imageWrapper}>
                <Media
                  src={participant.image || require(`../assets/userDefaultImage.png`)}
                  className={classes.image}
                  alt="Generic placeholder image"
                />
              </div>
              <div className={classes.participantName}>
                {participant.displayName}
              </div>
            </div>
            {
              wrapUp ? '' :
              <div
                className={classNames(classes.FutureBtnWrapper, {
                  [classes.hide]: wrapUp,
                })}
                onClick={() => removeFromFutureBtn(participant._id)}
            >
                <span>
                  Remove For Future Session(s)
                </span>
              </div>
            }
            <div className={classes.previousBtnWrapper} onClick={() => removeFromPreviousBtn(participant._id)}>
              <span>
                Remove From Previous Session
              </span>
            </div>
            {
              wrapUp ?
              <div className={classes.btnWrapper}>
                <div
                  className={classNames(classes.sessionBtn, {
                    [classes.hide]: isRemovedFromLastSession,
                  })}
                >
                  Session 3
                </div>
                <div className={classes.sessionBtn}>
                  Session 2
                </div>
                <div className={classes.sessionBtn}>
                  Session 1
                </div>
              </div> : ''
            }
          </div>
        );
      })
    );
  }

  render() {
    const { classes, createdBy } = this.props;
    return (
      <div className={classes.cardContainer}>
        <Card className={classes.card}>
          <CardBody>
            <div className={classes.cardTitle} style={{marginTop:0}}>
              Jam Leader(s):
            </div>
            <div className={classes.description}>
              Responsible for conducting the Jam, then posting as final fruit.
            </div>
            <div className={classes.participantInfoWrapper}>
              <div className={classes.imageWrapper}>
                <Media
                  src={createdBy.image || require(`../assets/userDefaultImage.png`)}
                  className={classes.image}
                  alt="Generic placeholder image"
                />
              </div>
              <div className={classes.participantName}>
                {createdBy.displayName}
              </div>
            </div>
            <div className={classes.cardTitle}>
              Participant(s):
            </div>
            <div className={classes.description}>
              Adjust participants before starting the next session.
            </div>
            {this.renderParticipants()}
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default injectSheet(styles)(ManagementParticipantsSessionCard);



// WEBPACK FOOTER //
// ./src/components/ManagementParticipantsSessionCard.js